var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadImageThumb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.425,
    height: 31.425,
    viewBox: "0 0 31.425 31.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_61528",
    "data-name": "Group 61528",
    transform: "translate(-1451.291 -651.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61527",
    "data-name": "Group 61527",
    transform: "translate(-53 21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76037",
    "data-name": "Path 76037",
    d: "M57.991,37.456,32.605,35.745a.671.671,0,0,1-.625-.715L33.692,9.643a.671.671,0,0,1,.715-.625L59.793,10.73a.672.672,0,0,1,.625.715L58.706,36.832A.671.671,0,0,1,57.991,37.456Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 1472.295, 626.023)",
    fill: "none",
    stroke: "#37509e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_61526",
    "data-name": "Group 61526",
    transform: "translate(-53 21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76039",
    "data-name": "Path 76039",
    d: "M58.794,33.748,38.248,32.363a.672.672,0,0,1-.625-.715l1.18-17.5a.671.671,0,0,1,.715-.625L60.064,14.9a.672.672,0,0,1,.625.715l-1.18,17.5A.671.671,0,0,1,58.794,33.748Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 1469.517, 624.108)",
    fill: "none",
    stroke: "#37509e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76040",
    "data-name": "Path 76040",
    d: "M48.234,22.279a2.192,2.192,0,1,1-2.04-2.335,2.193,2.193,0,0,1,2.04,2.335",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 1466.401, 621.317)",
    fill: "#aec9ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76041",
    "data-name": "Path 76041",
    d: "M47.515,21.272a2.192,2.192,0,1,1-2.04-2.335A2.193,2.193,0,0,1,47.515,21.272Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 1466.77, 621.763)",
    fill: "none",
    stroke: "#37509e",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76042",
    "data-name": "Path 76042",
    d: "M60.244,36.669a.252.252,0,0,0-.028-.134l-3.831-7.3a.613.613,0,0,0-.948-.181l-4.843,4.231a.862.862,0,0,1-1.216-.082l-1.56-1.786a.863.863,0,0,0-1.228-.072l-4.341,3.928a.248.248,0,0,0-.081.168l-.155,2.3a.248.248,0,0,0,.231.265L59.814,39.2a.249.249,0,0,0,.265-.231Z",
    transform: "matrix(0.998, -0.07, 0.07, 0.998, 1466.968, 617.076)",
    fill: "#aec9ea"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImageThumb);
export default __webpack_public_path__ + "static/media/upload-image-thumb.0d85f38e09e48315c8ffb6ce54c514a1.svg";
export { ForwardRef as ReactComponent };